<template>
	<UApp>
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</UApp>
</template>

<script setup lang="ts">
useHead({
	htmlAttrs: {
		lang: 'de',
	},
	link: [
		{
			rel: 'icon',
			type: 'image/png',
			href: '/img/hut.png',
		},
	],
})

useSeoMeta({
	title: 'Propellerfestival',
	description:
		'Das Propellerfestival ist ein Dankeschön in Form eines Musikfestivals für junge Menschen ab 16 Jahren, die sich ehrenamtlich engagieren. Euch erwarten andere Ehrenamtliche, gutes Essen und richtig gute Musik mit Bands und einem DJ.',
	ogDescription:
		'Das Propellerfestival ist ein Dankeschön in Form eines Musikfestivals für junge Menschen ab 16 Jahren, die sich ehrenamtlich engagieren. Euch erwarten andere Ehrenamtliche, gutes Essen und richtig gute Musik mit Bands und einem DJ.',
	twitterDescription:
		'Das Propellerfestival ist ein Dankeschön in Form eines Musikfestivals für junge Menschen ab 16 Jahren, die sich ehrenamtlich engagieren. Euch erwarten andere Ehrenamtliche, gutes Essen und richtig gute Musik mit Bands und einem DJ.',
	ogTitle: 'Propellerfestival',
	twitterTitle: 'Propellerfestival',
	ogImage: '/img/logo.svg',
	twitterImage: '/img/logo.svg',
	twitterCard: 'summary',
	ogUrl: 'https://propellerfestival.de',
})
</script>
